import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  CDW_BULK_UPDATE_ACTION_FEATURE_KEY,
  cdwBulkUpdateActionAdapter,
  type CdwBulkUpdateActionsState,
} from './cdw-bulk-update-action.reducer';

export const getCdwBulkUpdateActionState = createFeatureSelector<CdwBulkUpdateActionsState>(
  CDW_BULK_UPDATE_ACTION_FEATURE_KEY
);

const { selectEntities } = cdwBulkUpdateActionAdapter.getSelectors();

export const getCdwBulkUpdateActionEntities = createSelector(
  getCdwBulkUpdateActionState,
  (state: CdwBulkUpdateActionsState) => selectEntities(state)
);

export const selectBulkUpdateActionExists = (id: string) =>
  createSelector(getCdwBulkUpdateActionEntities, (entities) => !!entities[id]);

export const getBulkUpdateActionState = (id: string) =>
  createSelector(getCdwBulkUpdateActionEntities, (entities) => {
    const state = {
      isNextButtonDisabled: entities[id]?.isNextButtonDisabled ?? true,
      isCancellingJob: entities[id]?.isCancellingJob ?? false,
      bulkUpdateActionjob: entities[id]?.bulkUpdateActionJob ?? undefined,
      fieldUpdatesSummary: entities[id]?.fieldUpdatesSummary ?? [],
    };
    return state;
  });

export const getCdwBulkUpdateActionLoaded = createSelector(
  getCdwBulkUpdateActionState,
  (state: CdwBulkUpdateActionsState) => state.loaded
);
